
import React, { useState, useEffect } from 'react';
import {
  ArrowRight, Zap, Shield, Play, Eye, Star, TrendingUp, Search, BarChart, Cpu, CreditCard, Settings, PieChart, RotateCcw,
  BarChart3, SlidersHorizontal, FileBarChart, PlugZap, Banknote, ShoppingCart, Truck
} from 'lucide-react';
import Header from "./header";
import Footer from "./footer";
const IndustrySolutions = () => {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const [animationStep, setAnimationStep] = useState(0);
  const [scrollY, setScrollY] = useState(0);
  const [isVisible, setIsVisible] = useState({});
  const [activeFeature, setActiveFeature] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentTitle, setCurrentTitle] = useState(0);


  const [currentTitleIndex, setCurrentTitleIndex] = useState(0);

  const [imageLoaded, setImageLoaded] = useState(false);

  const titles = [
    "RECON KEY FEATURES",
    // "SEAMLESS PAYMENTS",
    // "SECURE TRANSACTIONS",
    // "SMART COLLECTIONS"
  ];

  const features = [
    {
      icon: <Banknote className="w-7 h-7" />,
      title: "BFSI",
      desc: "UPI, Cards, Wallets, POS, NEFT/IMPS/RTGS reconciliation across systems for seamless settlement.",
      color: "blue"
    },
    {
      icon: <ShoppingCart className="w-7 h-7" />,
      title: "E-Commerce & Retail",
      desc: "Reconcile orders, gateway files & bank settlements for real-time visibility and accuracy.",
      color: "purple"
    },
    {
      icon: <Truck className="w-7 h-7" />,
      title: "Logistics",
      desc: "COD vs partner payouts vs bank credits — all reconciled with automation and AI.",
      color: "green"
    }
  ];



  return (
    <div className="min-h-screen">
      <Header />
      <section
        className="py-12 px-4 sm:px-6 lg:px-8 bg-slate-50"
        style={{
          background: `linear-gradient(135deg, 
          rgba(59, 130, 246, 0.1) 0%, 
          rgba(147, 51, 234, 0.1) 50%, 
          rgba(219, 39, 119, 0.1) 100%
        )`,
          fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
        }}
      >
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div
            className="absolute top-20 left-10 w-32 h-32 bg-gradient-to-br from-blue-200/30 to-purple-200/30 rounded-full animate-pulse transform rotate-45"
            style={{ transform: `translateY(${scrollY * 0.1}px) rotate(45deg)` }}
          ></div>
          <div
            className="absolute top-40 right-20 w-24 h-24 bg-gradient-to-br from-indigo-200/40 to-blue-200/40 rounded-lg animate-bounce transform rotate-12"
            style={{ animationDelay: '1s', transform: `translateY(${scrollY * 0.15}px) rotate(12deg)` }}
          ></div>
          <div
            className="absolute bottom-20 left-20 w-16 h-16 bg-gradient-to-br from-purple-200/30 to-pink-200/30 rounded-full animate-pulse transform -rotate-12"
            style={{ animationDelay: '2s', transform: `translateY(${scrollY * 0.2}px) rotate(-12deg)` }}
          ></div>
          <div
            className="absolute bottom-40 right-10 w-20 h-20 bg-gradient-to-br from-cyan-200/40 to-blue-200/40 rounded-lg animate-bounce transform rotate-45"
            style={{ animationDelay: '0.5s', transform: `translateY(${scrollY * 0.12}px) rotate(45deg)` }}
          ></div>
        </div>
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            {/* Left Content */}
            <div className="space-y-6">
              <div className="space-y-4">
                {/* <div className="flex justify-start">
                  <div className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-500 to-purple-500 text-white px-4 py-2 rounded-full text-sm font-medium shadow-lg">
                    <Star className="w-4 h-4" />
                    <div className="text-center leading-tight">
                      Reconciliation with AI</div>
                  </div>
                </div> */}

                <div className="flex justify-start">
                  <div className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-500 to-purple-500 text-white px-4 py-1.5 rounded-full text-xs sm:text-sm font-medium shadow-md max-w-full">
                    <Star className="w-3 h-3 flex-shrink-0" aria-hidden="true" />
                    <p className="whitespace-normal leading-tight">
                      Reconciliation with AI
                    </p>
                  </div>
                </div>

                {/* <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight tracking-tight">
                  <div className="text-slate-800 font-bold mb-2">
                    From Complexity to Clarity
                  </div>
                  <div className="bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent font-semibold leading-snug">
                    Automating Reconciliation Across Industries
                  </div>
                </h1> */}

                <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight tracking-tight">
                  <div className="text-gray-800 font-semibold">
                    FROM COMPLEXITY TO CLARITY
                  </div>
                  <div className="text-lg sm:text-xl lg:text-1.5xl font-medium bg-gradient-to-r from-blue-600 via-purple-600 to-indigo-600 bg-clip-text text-transparent mt-1">
                    Automating Reconciliation Across Industries
                  </div>
                </h1>

                <p className="text-base text-slate-600 leading-relaxed font-normal">
                  Reconciliation doesn’t have to be manual, slow, or error-prone anymore. Our AI-powered Reconciliation Solution automates end-to-end matching of transactions, settlements, adjustments, and reporting across multiple systems. Designed for banks, fintechs, NBFCs, insurers, e-commerce, telecoms & enterprises, it ensures accuracy, speed & compliance — at scale.                </p>

                {/* Key Features */}
                {/* <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-4">
                  <div className="flex items-center gap-2">
                    <Cpu className="w-5 h-5 text-green-600" />
                    <span className="text-sm text-slate-700 font-medium">Automated Matching</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Search className="w-5 h-5 text-blue-600" />
                    <span className="text-sm text-slate-700 font-medium">Anomaly Detection</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <BarChart className="w-5 h-5 text-purple-600" />
                    <span className="text-sm text-slate-700 font-medium">Real-Time Insights</span>
                  </div>
                </div> */}

              </div>
            </div>

            {/* Right Content - Video Placeholder */}
            <div className="relative">
              <div className="relative rounded-xl overflow-hidden shadow-2xl bg-black/20 backdrop-blur-sm border border-white/10">
                <video
                  className="w-full h-auto rounded-xl"
                  autoPlay
                  muted
                  loop
                  playsInline
                  src="./recon1.mp4"
                  preload="metadata"
                >
                  <source src="/path/to/your/video.mp4" type="video/mp4" />
                  <source src="/path/to/your/video.webm" type="video/webm" />
                  Your browser does not support the video tag.
                </video>

                {/* Optional overlay for styling */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none rounded-xl"></div>
              </div>

              {/* Decorative elements */}
              <div className="absolute -top-4 -right-4 w-20 h-20 bg-purple-400/30 rounded-full blur-xl"></div>
              <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-blue-400/30 rounded-full blur-lg"></div>
            </div>
          </div>
        </div>
      </section>


      {/* <section className="py-8 px-4 sm:px-6 lg:px-8 bg-slate-50">
        <div className="max-w-5xl mx-auto">
          <div className="relative group">
            <img
              src="/reconwithAI.png"
              alt="Payment Gateway Platform Screenshot"
              className={`w-full h-auto rounded-xl shadow-lg transition-all duration-300 hover:shadow-xl ${imageLoaded ? 'opacity-100' : 'opacity-0'}`}
              onLoad={() => setImageLoaded(true)}
            />
            <div className="absolute -top-3 -right-3 w-16 h-16 bg-gradient-to-br from-slate-400/15 to-slate-500/15 rounded-full blur-lg"></div>
            <div className="absolute -bottom-4 -left-4 w-20 h-20 bg-gradient-to-br from-slate-500/15 to-slate-600/15 rounded-full blur-lg"></div>
          </div>
        </div>
      </section> */}

      <section className="py-12 bg-slate-50 px-4 sm:px-6 lg:px-8" >
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-4">
            <h2 className="block bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent text-2xl sm:text-3xl lg:text-4xl font-bold mb-3 animate-pulse hover:animate-none transition-all duration-500 hover:scale-105 cursor-default">
              {/* Complete Payment Gateway */}
              KEY FEATURES OF RECON
            </h2>

          </div>
          {/* Image Container */}
          <div className="relative group w-full">
            <div className="relative bg-white rounded-xl overflow-hidden transition-all duration-300">
              <img
                src="/reconFeatures.png" // Replace with your image path
                alt="Payment Gateway Platform Screenshot"
                className={`w-full h-auto max-h-100 object-cover transition-all duration-300 ${imageLoaded ? 'opacity-100' : 'opacity-0'
                  }`}
                onLoad={() => setImageLoaded(true)}
              />
            </div>
            {/* Decorative Elements */}
            <div className="absolute -top-3 -right-3 w-16 h-16 bg-gradient-to-br from-slate-400/15 to-slate-500/15 rounded-full blur-lg"></div>
            <div className="absolute -bottom-4 -left-4 w-20 h-20 bg-gradient-to-br from-slate-500/15 to-slate-600/15 rounded-full blur-lg"></div>
          </div>
        </div>
      </section>

      {/* Cards Sections */}

      <div className="py-16 px-4 bg-slate-50">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 animate-fade-in-up">
            <span className="inline-block animate-pulse bg-gradient-to-r from-blue-600 via-purple-600 to-cyan-600 bg-clip-text text-transparent">
              INDUSTRY USE CASES
            </span>{" "}
            {/* <span className="inline-block animate-bounce-slow">

                            Payment Gateway Suite?
                        </span> */}
          </h2>

          <style jsx>{`
                    @keyframes fade-in-up {
                        0% {
                            opacity: 0;
                            transform: translateY(20px);
                        }
                        100% {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }

                    @keyframes bounce-slow {
                        0%, 20%, 50%, 80%, 100% {
                            transform: translateY(0);
                        }
                        40% {
                            transform: translateY(-3px);
                        }
                        60% {
                            transform: translateY(-1px);
                        }
                    }

                    .animate-fade-in-up {
                        animation: fade-in-up 1s ease-out;
                    }

                    .animate-bounce-slow {
                        animation: bounce-slow 2s infinite;
                        animation-delay: 0.5s;
                    }
                `}</style>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6 mt-12">
            {features.map((feature, index) => (
              <div
                key={index}
                className="p-6 bg-white border border-gray-200 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 flex flex-col items-center text-center group hover:scale-[1.02] transition-transform"
              >
                <div className={`mb-4 p-4 rounded-full bg-${feature.color}-100 text-${feature.color}-600`}>
                  {feature.icon}
                </div>
                <h3 className="text-base font-semibold text-slate-800 mb-2">{feature.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{feature.desc}</p>
              </div>
            ))}
          </div>

        </div>
      </div>



      {/* Call to Action - Dark Theme */}
      <section className="py-8 bg-gradient-to-br from-blue-600 via-indigo-600 to-purple-700 relative overflow-hidden">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-10 left-10 w-32 h-32 bg-white/10 rounded-full animate-pulse"></div>
          <div className="absolute top-40 right-20 w-24 h-24 bg-white/5 rounded-lg animate-bounce transform rotate-45" style={{ animationDelay: '1s' }}></div>
          <div className="absolute bottom-20 left-20 w-16 h-16 bg-white/10 rounded-full animate-pulse" style={{ animationDelay: '2s' }}></div>
          <div className="absolute bottom-40 right-10 w-20 h-20 bg-white/5 rounded-lg animate-bounce transform -rotate-12" style={{ animationDelay: '0.5s' }}></div>

          <div className="absolute top-1/4 left-1/4 animate-float">
            <Zap className="w-8 h-8 text-white/20" />
          </div>
          <div className="absolute top-1/3 right-1/3 animate-float" style={{ animationDelay: '1.5s' }}>
            <Shield className="w-6 h-6 text-white/20" />
          </div>
          <div className="absolute bottom-1/3 left-1/3 animate-float" style={{ animationDelay: '3s' }}>
            <TrendingUp className="w-7 h-7 text-white/20" />
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
          {/* Main Content */}

          <div className="space-y-4 animate-fadeInUp">
            <h2 className="text-2xl sm:text-3xl lg:text-3xl font-bold text-white leading-tight animate-slideInLeft">
              Ready to Transform Your Reconciliation.
            </h2>
          </div>

          {/* CTA Button - Smaller and More Compact */}
          <div className="mt-6 animate-fadeInUp" style={{ animationDelay: '1.2s' }}>
            <button
              className="group relative inline-flex items-center gap-3 bg-gradient-to-r from-white to-blue-50 text-blue-700 px-8 py-3 rounded-xl font-semibold text-lg hover:from-yellow-300 hover:to-orange-300 hover:text-gray-900 transform hover:scale-105 transition-all duration-500 shadow-xl hover:shadow-yellow-300/50"
              onClick={() => {
                window.location.href = '/contact';
              }}
            >
              <Play className="w-5 h-5 group-hover:animate-bounce" />
              <span>Get In Touch</span>
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />

              {/* Button Glow Effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </button>
          </div>
        </div>

        <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          33% { transform: translateY(-10px) rotate(5deg); }
          66% { transform: translateY(5px) rotate(-5deg); }
        }
        
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        @keyframes slideInLeft {
          from { opacity: 0; transform: translateX(-50px); }
          to { opacity: 1; transform: translateX(0); }
        }
        
        @keyframes slideInRight {
          from { opacity: 0; transform: translateX(50px); }
          to { opacity: 1; transform: translateX(0); }
        }
        
        @keyframes slideInUp {
          from { opacity: 0; transform: translateY(40px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        .animate-float {
          animation: float 4s ease-in-out infinite;
        }
        
        .animate-fadeInUp {
          animation: fadeInUp 0.8s ease-out forwards;
          opacity: 0;
        }
        
        .animate-slideInLeft {
          animation: slideInLeft 0.8s ease-out forwards;
          opacity: 0;
        }
        
        .animate-slideInRight {
          animation: slideInRight 0.8s ease-out forwards;
          opacity: 0;
        }
        
        .animate-slideInUp {
          animation: slideInUp 0.8s ease-out forwards;
          opacity: 0;
        }
      `}</style>
      </section>
      <Footer />
    </div>
  );
};

export default IndustrySolutions;